import { executePost } from '@/api/AxiosUtil'

import axios from 'axios'

export const productPrice = (specs) => {
  return executePost('/api/v3/order/pricing/calculate', specs)
}

export const getProducts = (products) => {
  const ext = products.slice(-5)
  if (ext === '.json') {
    products = products.substring(0, products.length - 5)
  }

  const productsObj = '/api/v3/specs/PRODUCT_ORDER_SPEC/' + products

  return new Promise((resolve, reject) => {
    axios
      .get(productsObj)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => reject())
  })
}

export const calculatePrice = (priceObject) => {
  return new Promise((resolve, reject) => {
    axios
      .post('/api/v3/order/pricing/calculate', priceObject)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => reject())
  })
}

export const calculateMailingPrice = (priceObject) => {
  return new Promise((resolve, reject) => {
    axios
      .post('/api/v3/order/pricing/calculate-mailing', priceObject)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => reject())
  })
}

export const getUserPrintTemplates = () => {
  return new Promise((resolve, reject) => {
    axios
      .get('/api/v3/user-print-template')
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => reject())
  })
}

export const saveUserPrintTemplate = (template) => {
  return new Promise((resolve, reject) => {
    axios
      .post('/api/v3/user-print-template', { template: template })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => reject())
  })
}

export const deleteUserPrintTemplate = (id) => {
  return new Promise((resolve, reject) => {
    axios
      .delete('/api/v3/user-print-template/' + id)
      .then((response) => {
        resolve(id)
      })
      .catch((error) => {
        reject()
      })
  })
}
